export default class Client {
  constructor(Client, { id, name }) {
    this.id = id || 0;
    this.name = name || 0;
  }
}
